export enum UserTypeOrderType {
  NORMAL = 1 << 0,
  CANDC = 1 << 1,
}
